export const CHATBOT_EXPERIMENT = {
  chatbotExperiment: {
    id: 'cad-975_chatbot_front_page',
    variants: {
      VARIANT: 'treatment',
    },
  },
};

export const VERTICAL_COMPARISON_TAB_EXPERIMENT = {
  verticalComparisonTabExperiment: {
    id: 'EXPLAT-1627_homepage_remove_explore_button',
    variants: {
      VARIANT: 'treatment',
    },
  },
};

export const EXPERIMENTS = {
  ...CHATBOT_EXPERIMENT,
  ...VERTICAL_COMPARISON_TAB_EXPERIMENT,
};
